import { render, staticRenderFns } from "./Siteweb.vue?vue&type=template&id=5996d59e&scoped=true&"
import script from "./Siteweb.vue?vue&type=script&lang=js&"
export * from "./Siteweb.vue?vue&type=script&lang=js&"
import style1 from "./Siteweb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996d59e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VRow})
